export class MessageRequest{
    public MessageStatusID?: number;
    public MessageID?: number;
    public MessageCode: string;
    public HasRead: boolean;
    public HasDelete: boolean;
    public UpdateType: string;
}